export default {
    name: "pay",
    data () {
        return{
            payData: [
                {
                    icon: 'pay',
                    title: '支付通道',
                    info: '我们已对接了多条优质的支付通道，您只需简单配置即可使用。',
                    linkTxt: '查看支付通道详情',
                    linkHref: 'https://www.yuque.com/lt/sysc/nzgzb8',
                    linkType: 'href'
                },
                {
                    icon: 'software',
                    title: '插件适配的软件',
                    info: '收款小精灵适配了零售业众多的收银软件，您只需3分钟安装即可接通移动支付。',
                    linkTxt: '查看所有适配软件',
                    linkHref: 'https://www.yuque.com/books/share/a2dedfb7-e3e1-4e6c-b6cb-43a844f3d27f?# 《默认知识库》',
                    linkType: 'href'
                },
                {
                    icon: 'shop',
                    title: '联拓数字化方案',
                    info: '联拓数科面向连锁加盟企业推出的一站式门店数字化SaaS系统解决方案，让客户能够高效地运营自己的私域流量和管理多家直营或加盟门店。',
                    linkTxt: '了解详细方案',
                    linkHref: '/n7digitalOverview',
                    linkType: 'router'
                },
                {
                    icon: 'service',
                    title: '寻求本地服务商',
                    info: '联拓数科专业的4000多家服务商遍布全国380个城市，可以随时为您提供就地的贴身服务，不管安装硬件，还是做软件调试，我们都可以随时为您联络上门。',
                    linkTxt: '联络服务商',
                    linkHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
                    linkType: 'href'
                }
            ]
        }
    }
};
